


























































































































































































































































































































































































import Vue, { PropType } from 'vue';
import moment from 'moment';
import { IInvoice, IQuote } from '@/models';
import InvoiceSummaryDetailItemsTable from '@/components/invoice/InvoiceDetailSummaryItemsTable.vue';

export default Vue.extend({
  name: 'InvoiceSummaryDetailCard',
  components: {
    InvoiceSummaryDetailItemsTable
  },
  props: {
    invoice: { type: Object as PropType<IInvoice> }
  },

  data() {
    return {
      moment,
      loading: false
    };
  },
  computed: {
    airwayIcon(): string {
      return require('@/assets/logos/jamesway_logo.png');
    },
    proposalNumbers(): string[] {
      return this.invoice.quotes
        .map((quote: IQuote | number) => quote.toString())
        .filter((quoteNumber: string) => quoteNumber);
    }
  }
});
